<template>
    <div v-if="!isLoading && isLogged" class="member-info">
        <div v-if="memberTypeId && isBasicMember()">
            <ul class="member-info-content justify-content-end px-1">
                <li>
                    <span class="member-info-type" :style="{ color: themeTextColor }">
                        {{ $t('menu.member_type') }}{{ $t('member_type.' + memberType) }}
                    </span>
                </li>
                <li>
                    <span class="member-info-type" :style="{ color: themeTextColor }">
                        AUBE ID：{{ aubeId }}
                    </span>
                </li>
            </ul>
        </div>
        <div v-else>
            <ul class="member-info-content px-1" :class="isProgressMember() ? 'justify-content-end' : ''">
                <li v-if="!memberType">
                    <span class="member-info-type" :style="{ color: themeTextColor }">
                        {{ $t('menu.member_type') }} -
                    </span>
                </li>
                <li v-else>
                    <span class="member-info-type" :style="{ color: themeTextColor }">
                        {{ $t('menu.member_type') }}{{ $t('member_type.' + memberType) }}
                    </span>
                </li>
                <!-- check not progess member -->
                <li v-if="memberTypeId && memberTypeId !== 4000">
                    <span class="member-info-type" :style="{ color: themeTextColor }">
                        ForceClub ID：{{ forceClubId || '-' }}
                    </span>
                </li>
                <li>
                    <span class="member-info-type" :style="{ color: themeTextColor }">
                        Quest ID：{{ questId }}
                    </span>
                </li>
            </ul>
            <ul class="aube-id px-1 pt-1" v-if="isLogged">
                <li>
                    <span class="member-info-type" :style="{ color: themeTextColor }">
                        AUBE ID：{{ aubeId }}
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD, MEMBER_TYPE_ID_ADVANCE, MEMBER_TYPE_ID_ADVANCE_CHILD } from '../../utils/Const';

export default {
    name: 'MemberInfo',
    props: {
        isLogged: Boolean,
        memberType: String,
        memberTypeId: String,
        forceClubId: String,
        questId: String,
        aubeId: String,
        isLoading: Boolean,
        themeTextColor: {
            type: String,
            default: '#000'
        }
    },
    methods: {
        isBasicMember() {
           return ![MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD, MEMBER_TYPE_ID_ADVANCE, MEMBER_TYPE_ID_ADVANCE_CHILD].includes(this.memberTypeId)
        },

        isProgressMember() {
           return [MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD].includes(this.memberTypeId)
        }
    }
}
</script>

<style lang="scss" scoped>
.aube-id {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.member-info {
    list-style: none;
    display: flex;
    flex-direction: column;

    .member-info-content {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        gap: 30px;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    li {
        margin: 0;
        padding: 5px 0;

        .member-info-type {
            font-size: 16px;
            white-space: nowrap;
        }
    }
    @media screen and (max-width: 376px) {
        .member-info-content {
            justify-content: flex-start;
            max-width: 100%;
            overflow-x: auto;
            overflow-y: hidden;
            white-space: nowrap;
            -webkit-overflow-scrolling: touch;
            gap: 10px;
            padding-top: 10px;
        }

        .member-info-content li {
            flex-shrink: 0;
        }
    }

    @media screen and (max-width: 768px) {
        .member-info {
            position: static !important;
            top: auto !important;
            z-index: auto !important;
            gap: 0px;
            margin: 0;
            padding: 0;
        }
        .member-info-content {
            max-width: 100%;
            overflow-x: auto;
            gap: 10px;
            padding-top: 20px;
            overflow-y: hidden;
            white-space: nowrap;
            -webkit-overflow-scrolling: touch;
        }
        li {
            flex-shrink: 0;
            padding: 0 2px;
            min-width: auto;
            .member-info-type {
                font-size: 9px;
            }
        }
    }
}
</style>
